import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a5fc5b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { style: {"margin-left":"60px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("店铺名称：")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("店铺id：")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("订单id：")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("售后编号：")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("售后类型：")
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("当前状态：")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("申请时间：")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("申请原因：")
const _hoisted_13 = ["src"]
const _hoisted_14 = { style: {"margin-left":"60px","position":"absolute"} }
const _hoisted_15 = {
  class: "name",
  style: {"margin-top":"-30px"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("商品名称：")
const _hoisted_17 = { style: {"margin-top":"15px"} }
const _hoisted_18 = ["src"]
const _hoisted_19 = { style: {"margin-left":"60px"} }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("会员编号：")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("会员昵称：")
const _hoisted_22 = { key: 5 }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("售后详情")
const _hoisted_24 = { style: {"margin-top":"20px"} }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "商品信息", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","margin-top":"20px"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商品图片"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商品名称"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "价格"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "数量"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "总价"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "支付金额"),
  /*#__PURE__*/_createElementVNode("div", { class: "item item2" }, "商品描述")
], -1))
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = { class: "item" }
const _hoisted_30 = { class: "item" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "item" }
const _hoisted_33 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "商家售后" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event)),
          onChange: $setup.activeKeyChange,
          style: {"margin-top":"10px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeData, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: item.type,
                tab: item.title +'('+ item.count +')'
              }, null, 8, ["tab"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'shop')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("img", {
                    src: record.shop.logo,
                    style: {"width":"50px","height":"50px","position":"absolute","margin-top":"10px"}
                  }, null, 8, _hoisted_1),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _hoisted_3,
                      _createElementVNode("span", null, _toDisplayString(record.shop.name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_4,
                      _createElementVNode("span", null, _toDisplayString(record.shop_id), 1)
                    ]),
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.shop.type_desc), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'aftersale')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createElementVNode("span", null, _toDisplayString(record.order.id), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_7,
                    _createElementVNode("span", null, _toDisplayString(record.order.order_sn), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(record.refund_type), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'refund_status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _hoisted_10,
                    _createElementVNode("span", null, [
                      _createVNode(_component_a_tag, { color: "blue" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(record.status), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_11,
                    _createElementVNode("span", null, _toDisplayString(record.create_time), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_12,
                    _createElementVNode("span", null, _toDisplayString(record.refund_reason), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'goods')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(record.order_goods, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createElementVNode("img", {
                      src: item.image,
                      style: {"width":"50px","height":"50px","margin-top":"-25px","position":"absolute"}
                    }, null, 8, _hoisted_13),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("span", null, _toDisplayString(item.goods_name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.goods_num) + "×" + _toDisplayString(item.goods_price), 1)
                    ])
                  ]))
                }), 256))
              : _createCommentVNode("", true),
            (column.key === 'user')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createElementVNode("img", {
                    src: record.user.avatar,
                    style: {"width":"50px","height":"50px","position":"absolute","margin-top":"10px"}
                  }, null, 8, _hoisted_18),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _hoisted_20,
                      _createElementVNode("span", null, _toDisplayString(record.user.sn), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_21,
                      _createElementVNode("span", null, _toDisplayString(record.user.nickname), 1)
                    ]),
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.user.mobile), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.detail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      title: "售后详情",
      footer: null,
      width: "45%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          title: "用户详情",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "用户姓名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.user.nickname), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "头像" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  src: _ctx.detailData.user.avatar,
                  style: {"width":"50px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "手机号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.user.mobile), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "sn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.user.sn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "创建时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.user.create_time), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions, {
          title: "店铺详情",
          bordered: "",
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "用户姓名" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.shop.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "店铺logo" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  src: _ctx.detailData.shop.logo,
                  style: {"width":"50px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "店铺描述" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.shop.type_desc), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_descriptions, {
          title: "订单详情",
          bordered: "",
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "订单编号" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.order.order_sn), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "订单状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.order.order_status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "支付方式" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.order.pay_way), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "订单金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.order.order_amount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "总价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.order.total_amount), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "售后类型" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.refund_type), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "售后金额" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.refund_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "售后原因" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.refund_reason), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.status), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _hoisted_26,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.order_goods, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: {"display":"flex","margin-bottom":"100px"}
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_a_image, {
                  src: item.image,
                  style: {"height":"40px"}
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_28, _toDisplayString(item.goods_name), 1),
              _createElementVNode("div", _hoisted_29, _toDisplayString(item.goods_price), 1),
              _createElementVNode("div", _hoisted_30, _toDisplayString(item.goods_num), 1),
              _createElementVNode("div", _hoisted_31, _toDisplayString(item.total_price), 1),
              _createElementVNode("div", _hoisted_32, _toDisplayString(item.total_pay_price), 1),
              _createElementVNode("div", _hoisted_33, _toDisplayString(item.spec_value), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}